<div class="b-pulldowncontainer">
  <ng-content select="[slot=main]"></ng-content>

  <div
    class="expanded-content"
    [@expandCollapse]="visibleDropbar ? 'open' : 'closed'"
  >
    <ng-content select="[slot=drawer]"></ng-content>
  </div>
</div>

<div class="b-pulldowncontainer-togglesection">
  <button class="b-pulldowncontainer-togglebutton" (click)="toggleDropbar()">
    <div
      [class.symbol-arrow-drop-down]="!visibleDropbar"
      [class.symbol-arrow-drop-up]="visibleDropbar"
      class="toggle-arrow-icon"
    ></div>
  </button>
</div>
